<div class="container-fluid complyon-page employees-page px-3 px-md-4 px-xl-4 py-3">
  <div class="complyon-shell employees-shell mx-auto">
    <section class="mb-3">
      <h1 class="complyon-title employees-title mb-2 text-l">Employee register</h1>
      <p class="complyon-subtitle employees-subtitle mb-0 text-s">
        Active employees under ongoing compliance - annual policies, declarations, conflicts, access reviews and exits. Joiners originate in OnboardOS.
      </p>
    </section>

    <section class="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-3">
      <div class="d-flex flex-wrap align-items-center gap-1">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          type="button"
          class="btn doa-tab-btn fw-semibold"
          :class="{ active: active_tab === tab.id }"
          @click="set_tab(tab.id)"
        >
          <span>{{ tab.label }}</span>
          <span v-if="tab.count !== undefined" class="doa-tab-count">{{ tab.count }}</span>
        </button>
      </div>

      <button type="button" class="btn doa-reset-btn d-inline-flex align-items-center gap-1">
        <i class="bi bi-arrow-clockwise"></i>
        <span>Reset sample</span>
      </button>
    </section>

    <div v-if="active_tab === 'register'">
      <section class="mb-3">
        <div class="rounded-4 border px-3 py-3" style="background:#e8f8f5;border-color:#bce9df;">
          <div class="d-flex align-items-start gap-2 text-s">
            <i class="bi bi-arrow-repeat mt-1 text-success"></i>
            <div>
              <strong>Originated in OnboardOS, monitored in Complyon.</strong>
              Employees are onboarded & vetted in OnboardOS; Complyon tracks their ongoing compliance and re-triggers onboarding when obligations lapse.
            </div>
          </div>
        </div>
      </section>

      <section class="row g-3 mb-3">
        <div v-for="card in register_cards" :key="card.label" class="col-12 col-md-6 col-xl-3">
          <article class="complyon-card rounded-4 p-3 h-100">
            <div class="complyon-stat-label text-xs">{{ card.label }}</div>
            <div class="complyon-stat-value text-l" :class="card.accent === 'green' ? 'text-success' : card.accent === 'orange' ? 'text-warning-emphasis' : card.accent === 'red' ? 'text-danger' : 'text-dark'">
              {{ card.value }}
            </div>
            <div class="complyon-stat-note mt-3 text-xs">{{ card.note }}</div>
          </article>
        </div>
      </section>

      <section class="complyon-panel employees-panel rounded-4 overflow-hidden">
        <div class="d-flex align-items-start justify-content-between gap-2 px-3 pt-3">
          <div>
            <div class="complyon-section-title text-s">Employee compliance register</div>
            <div class="complyon-section-subtitle text-xs">Each employee's compliance profile - acknowledgements, training, declarations, access and fit-and-proper.</div>
          </div>
          <button type="button" class="btn config-navbar-primary-action finance-action-btn" @click="open_employee_modal">
            <i class="bi bi-plus-lg"></i>
            <span>Add employee</span>
          </button>
        </div>

        <div class="px-3 pb-2 pt-2">
          <div class="d-flex flex-wrap align-items-center gap-1 mb-2">
            <button
              v-for="filter in visible_employee_filters"
              :key="filter.id"
              type="button"
              class="btn doa-tab-btn fw-semibold"
              :class="{ active: filter.active }"
              @click="set_employee_filter(filter.id)"
            >
              <span>{{ filter.label }}</span>
            </button>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table complyon-table employees-table align-middle mb-0">
            <thead>
              <tr>
                <th class="ps-3 text-xs">Ref</th>
                <th class="text-xs">Employee</th>
                <th class="text-xs">Role</th>
                <th class="text-xs">Dept</th>
                <th class="text-xs">Compliance</th>
                <th class="text-xs">Outstanding</th>
                <th class="text-xs">Status</th>
                <th class="pe-3"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in filtered_employee_rows"
                :key="row.ref"
                class="employees-row-clickable"
                role="button"
                tabindex="0"
                @click="open_employee_drawer(row.ref)"
                @keydown.enter.prevent="open_employee_drawer(row.ref)"
                @keydown.space.prevent="open_employee_drawer(row.ref)"
              >
                <td class="ps-3"><div class="procurement-id">{{ row.ref }}</div></td>
                <td><div class="employees-name">{{ row.employee }}</div></td>
                <td>{{ row.role }}</td>
                <td>{{ row.dept }}</td>
                <td>
                  <div class="d-flex align-items-center gap-3">
                    <div class="employees-progress flex-grow-1">
                      <div class="progress rounded-pill">
                        <div class="progress-bar rounded-pill" :style="{ width: `${row.compliance}%`, backgroundColor: row.accent }"></div>
                      </div>
                    </div>
                    <div class="employees-progress-value">{{ row.compliance }}%</div>
                  </div>
                </td>
                <td>{{ row.outstanding }}</td>
                <td>
                  <span class="badge complyon-badge employees-badge text-xs" :class="row.status.class">{{ row.status.label }}</span>
                </td>
                <td class="pe-3 text-end"><i class="bi bi-chevron-right finance-arrow"></i></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <div v-else-if="active_tab === 'obligations'">
      <section class="row g-3">
        <div
          v-for="panel in outstanding_sections"
          :key="panel.title"
          class="col-12 col-lg-6"
        >
          <article class="complyon-panel rounded-4 overflow-hidden h-100">
            <div class="d-flex align-items-start justify-content-between gap-2 px-3 pt-3">
              <div>
                <div class="complyon-section-title text-s">{{ panel.title }}</div>
                <div class="complyon-section-subtitle text-xs">{{ panel.count }}</div>
              </div>
              <span class="badge rounded-pill finance-badge bg-warning-subtle text-warning-emphasis">{{ panel.badge }}</span>
            </div>

            <div class="px-3 pb-2">
              <div
                v-for="row in panel.rows"
                :key="`${panel.title}-${row.name}-${row.detail}`"
                class="d-flex align-items-center justify-content-between gap-3 py-3 border-bottom employees-obligation-row"
                role="button"
                tabindex="0"
                @click="open_employee_drawer(row.employee_ref)"
                @keydown.enter.prevent="open_employee_drawer(row.employee_ref)"
                @keydown.space.prevent="open_employee_drawer(row.employee_ref)"
              >
                <div class="d-flex align-items-start gap-3 min-w-0">
                  <div class="rounded-3 d-inline-flex align-items-center justify-content-center flex-shrink-0" style="width:32px;height:32px;background:#fdf1e5;color:#c75a06;">
                    <i class="bi" :class="row.icon"></i>
                  </div>
                  <div class="min-w-0">
                    <div class="procurement-name text-truncate">{{ row.name }}</div>
                    <div class="procurement-request-meta">{{ row.detail }}</div>
                  </div>
                </div>
                <i class="bi bi-chevron-right finance-arrow"></i>
              </div>
            </div>
          </article>
        </div>
      </section>
    </div>

    <div v-else-if="active_tab === 'department-scores'">
      <section class="row g-3">
        <div v-for="dept in department_cards" :key="dept.dept" class="col-12 col-md-6 col-xl-4">
          <article class="complyon-card employees-card rounded-4 p-3 h-100">
            <div class="d-flex align-items-start justify-content-between gap-3">
              <div class="complyon-stat-label text-xs">{{ dept.dept }}</div>
              <span class="badge rounded-pill finance-badge" :class="dept.accent === 'green' ? 'bg-success-subtle text-success-emphasis' : dept.accent === 'orange' ? 'bg-warning-subtle text-warning-emphasis' : 'bg-danger-subtle text-danger-emphasis'">
                {{ dept.value }}
              </span>
            </div>

            <div class="mt-2">
              <div class="d-flex align-items-center gap-2">
                <div class="complyon-stat-value text-l" :class="dept.accent === 'green' ? 'text-success' : dept.accent === 'orange' ? 'text-warning-emphasis' : 'text-danger'">{{ dept.staff }}</div>
                <div class="text-xs">staff</div>
                <div v-if="dept.note" class="text-xs text-danger">{{ dept.note }}</div>
              </div>
            </div>

            <div class="mt-3">
              <div class="rounded-1 overflow-hidden" style="height:8px;background:#edf1f6;">
                <div class="h-100 rounded-1" :style="{ width: `${dept.bar}%`, backgroundColor: dept.accent === 'green' ? '#13856f' : dept.accent === 'orange' ? '#c75a06' : '#c1261a' }"></div>
              </div>
            </div>

            <div class="mt-3">
              <button
                v-for="person in dept.people"
                :key="`${dept.dept}-${person.name}`"
                type="button"
                class="employees-dept-person"
                @click="open_employee_drawer(person.employee_ref)"
              >
                <span class="d-flex align-items-center gap-2 min-w-0">
                  <span class="rounded-circle flex-shrink-0" :style="{ width: '8px', height: '8px', backgroundColor: person.color }"></span>
                  <span class="text-truncate">{{ person.name }}</span>
                </span>
                <span class="d-flex align-items-center gap-2 flex-shrink-0">
                  <span class="fw-semibold text-xs">{{ person.score }}%</span>
                  <i class="bi bi-chevron-right finance-arrow"></i>
                </span>
              </button>
            </div>
          </article>
        </div>
      </section>
    </div>
  </div>

  <div v-if="show_employee_modal" class="finance-modal-backdrop" @click.self="close_employee_modal">
    <div class="finance-modal-shell employees-modal" role="dialog" aria-modal="true" aria-label="Add employee">
      <div class="finance-modal-header employees-modal-header">
        <div>
          <h3 class="employees-modal-title">Add employee</h3>
          <p class="employees-modal-subtitle">Register an active employee for monitoring. Onboarding & vetting happen in OnboardOS.</p>
        </div>
        <button type="button" class="employees-modal-close" @click="close_employee_modal">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="finance-modal-body employees-modal-body">
        <div class="row g-3">
          <div class="col-12">
            <label class="employees-modal-label">Name</label>
            <input v-model="employee_form.name" type="text" class="employees-modal-input" placeholder="Full name">
          </div>
          <div class="col-12 col-md-6">
            <label class="employees-modal-label">Role</label>
            <input v-model="employee_form.role" type="text" class="employees-modal-input" placeholder="e.g. Analyst">
          </div>
          <div class="col-12 col-md-6">
            <label class="employees-modal-label">Department</label>
            <select v-model="employee_form.department" class="employees-modal-input">
              <option v-for="department in employee_departments" :key="department" :value="department">{{ department }}</option>
            </select>
          </div>
          <div class="col-12 col-md-6">
            <label class="employees-modal-label">Manager</label>
            <input v-model="employee_form.manager" type="text" class="employees-modal-input" placeholder="">
          </div>
          <div class="col-12 col-md-6">
            <label class="employees-modal-label">Joined</label>
            <input v-model="employee_form.joined" type="text" class="employees-modal-input" placeholder="e.g. Mar 2026">
          </div>
          <div class="col-12">
            <label class="employees-modal-label">Status</label>
            <select v-model="employee_form.status" class="employees-modal-input">
              <option v-for="status in employee_statuses" :key="status" :value="status">{{ status }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="finance-modal-footer employees-modal-footer">
        <button type="button" class="btn btn-link text-decoration-none employees-modal-secondary" @click="close_employee_modal">Cancel</button>
        <button type="button" class="btn config-navbar-primary-action" @click="create_employee">
          <i class="bi bi-plus-lg"></i>
          <span>Create</span>
        </button>
      </div>
    </div>
  </div>

  <div v-if="active_employee_drawer" class="command-centre-drawer-backdrop" @click.self="close_employee_drawer">
    <aside class="command-centre-drawer employees-drawer" role="dialog" aria-modal="true" :aria-label="active_employee_drawer.name">
      <header class="command-centre-drawer-header border-bottom">
        <div class="d-flex align-items-start justify-content-between gap-3">
          <div class="min-w-0">
            <div class="command-centre-drawer-kicker">{{ active_employee_drawer.section }}</div>
            <h2 class="command-centre-drawer-title mb-1 mt-1">{{ active_employee_drawer.name }}</h2>
            <div class="command-centre-drawer-subtitle">{{ active_employee_drawer.subtitle }}</div>
          </div>
          <div class="d-flex align-items-center gap-2 flex-shrink-0">
            <span class="badge complyon-badge text-xs" :class="active_employee_drawer.status_class">{{ active_employee_drawer.status }}</span>
            <button type="button" class="btn btn-link p-0 command-centre-drawer-close" @click="close_employee_drawer" aria-label="Close drawer">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>
        </div>
      </header>

      <div class="command-centre-drawer-body employees-drawer-body">
        <div class="employees-drawer-callout">
          <i class="bi bi-arrow-repeat"></i>
          <span>{{ active_employee_drawer.callout }}</span>
        </div>

        <div class="employees-drawer-topgrid">
          <article class="employees-drawer-score-card">
            <div class="employees-drawer-section-kicker">Compliance score</div>
            <div class="employees-drawer-score-row">
              <div class="employees-drawer-score" :class="active_employee_drawer.score_tone">{{ active_employee_drawer.score }}%</div>
              <div class="employees-drawer-score-bar">
                <span :style="{ width: `${active_employee_drawer.score}%` }"></span>
              </div>
            </div>
          </article>

          <article class="employees-drawer-score-card">
            <div class="employees-drawer-section-kicker">Current year</div>
            <div class="employees-drawer-meta-value">{{ active_employee_drawer.joined }}</div>
          </article>

          <article class="employees-drawer-score-card">
            <div class="employees-drawer-section-kicker">Fit & proper</div>
            <div class="employees-drawer-meta-value">{{ active_employee_drawer.fit_proper }}</div>
          </article>

          <article class="employees-drawer-score-card">
            <div class="employees-drawer-section-kicker">Open items</div>
            <div class="employees-drawer-meta-value">{{ active_employee_drawer.open_items }}</div>
          </article>
        </div>

        <div class="employees-drawer-chip-groups">
          <div v-for="(group, groupIndex) in active_employee_drawer.chip_groups" :key="`${active_employee_drawer.name}-group-${groupIndex}`" class="employees-drawer-chip-group">
            <span v-for="chip in group" :key="chip" class="employees-drawer-chip">{{ chip }}</span>
          </div>
        </div>

        <section class="employees-drawer-section">
          <div class="employees-drawer-section-title">Primary responsibilities</div>
          <div class="employees-drawer-list">
            <article v-for="entry in active_employee_drawer.primary_items" :key="`${active_employee_drawer.name}-${entry.title}`" class="employees-drawer-item">
              <div class="employees-drawer-item-main">
                <div class="employees-drawer-item-title">{{ entry.title }}</div>
                <div v-if="entry.subtitle" class="employees-drawer-item-subtitle">{{ entry.subtitle }}</div>
              </div>
              <span v-if="entry.state" class="employees-drawer-item-state" :class="`is-${entry.tone}`">{{ entry.state }}</span>
            </article>
          </div>
        </section>

        <section v-for="section in active_employee_drawer.sections" :key="`${active_employee_drawer.name}-${section.title}`" class="employees-drawer-section">
          <div class="employees-drawer-section-title">{{ section.title }}</div>
          <div class="employees-drawer-list">
            <article v-for="entry in section.items" :key="`${section.title}-${entry.title}-${entry.subtitle}`" class="employees-drawer-item">
              <div class="employees-drawer-item-main">
                <div class="employees-drawer-item-title">{{ entry.title }}</div>
                <div v-if="entry.subtitle" class="employees-drawer-item-subtitle">{{ entry.subtitle }}</div>
              </div>
              <span v-if="entry.state" class="employees-drawer-item-state" :class="`is-${entry.tone}`">{{ entry.state }}</span>
            </article>
          </div>
        </section>

        <section v-if="active_employee_drawer.alerts.length" class="employees-drawer-section">
          <div class="employees-drawer-section-title">Alerts</div>
          <div class="employees-drawer-list">
            <article v-for="alert in active_employee_drawer.alerts" :key="alert" class="employees-drawer-item employees-drawer-item-alert">
              <div class="employees-drawer-item-main">
                <div class="employees-drawer-item-subtitle">{{ alert }}</div>
              </div>
            </article>
          </div>
        </section>

        <section class="employees-drawer-section">
          <div class="employees-drawer-section-title">Acknowledgements & certificates</div>
          <div class="employees-drawer-records">
            <article v-for="record in active_employee_drawer.records" :key="`${active_employee_drawer.name}-${record.title}`" class="employees-drawer-record">
              <div class="employees-drawer-record-title">{{ record.title }}</div>
              <div v-if="record.subtitle" class="employees-drawer-record-subtitle">{{ record.subtitle }}</div>
              <div class="employees-drawer-record-link">{{ record.state }}</div>
            </article>
          </div>
        </section>

        <section class="employees-drawer-section">
          <div class="employees-drawer-section-title">Recommended action</div>
          <div class="employees-drawer-recommendation">{{ active_employee_drawer.recommended_action }}</div>
        </section>
      </div>

      <div class="command-centre-drawer__footer employees-drawer-footer">
        <button type="button" class="btn btn-link text-decoration-none employees-drawer-footer-link">Re-verify in OnboardOS</button>
        <button type="button" class="btn config-navbar-primary-action">Edit employee</button>
      </div>
    </aside>
  </div>
</div>
